var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTampering(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2217_6749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.375 52.4995C47.8723 52.4995 48.3492 52.302 48.7008 51.9503C49.0525 51.5987 49.25 51.1218 49.25 50.6245V20.6245L36.125 7.49951H30.5H24.875",
    stroke: "#FBBF00",
    strokeWidth: 3.75,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.625 52.4995C13.1277 52.4995 12.6508 52.302 12.2992 51.9503C11.9475 51.5987 11.75 51.1218 11.75 50.6245V9.37451C11.75 8.87723 11.9475 8.40032 12.2992 8.04869C12.6508 7.69706 13.1277 7.49951 13.625 7.49951H19.1",
    stroke: "#00C7EB",
    strokeWidth: 3.75,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 52.4995H26.2812",
    stroke: "#26BC96",
    strokeWidth: 3.75,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2217_6749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5766 19.2979L37.4516 6.17295C37.2773 5.99889 37.0705 5.86086 36.8428 5.76676C36.6152 5.67265 36.3713 5.62432 36.125 5.62451H13.625C12.6304 5.62451 11.6766 6.0196 10.9733 6.72286C10.2701 7.42612 9.875 8.37995 9.875 9.37451V50.6245C9.875 51.6191 10.2701 52.5729 10.9733 53.2762C11.6766 53.9794 12.6304 54.3745 13.625 54.3745H47.375C48.3696 54.3745 49.3234 53.9794 50.0266 53.2762C50.7299 52.5729 51.125 51.6191 51.125 50.6245V41V34L42.25 36L36.125 46.5L40.75 35L51.125 30.5V28.5V20.6245C51.1252 20.3782 51.0769 20.1343 50.9828 19.9067C50.8887 19.6791 50.7506 19.4722 50.5766 19.2979ZM36.125 20.6245V10.312L46.4375 20.6245H36.125Z",
    fill: "#6D2FEC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2217_6749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 60,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2217_6749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 60,
    fill: "white",
    transform: "translate(30.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTampering);
export default __webpack_public_path__ + "static/media/Tampering.44bee28b9cad4bc3de54ff9dc6f457f6.svg";
export { ForwardRef as ReactComponent };